import React, { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { ActionGridInput } from 'models/order-input/shared';
import { formatCurrency } from 'utils/format';
import { CurrencyContext } from 'context/currency';

type ConstructionSummaryActionsProps = {
    actions: ActionGridInput[];
    isWarranty: boolean;
};
const ConstructionSummaryActions: FC<ConstructionSummaryActionsProps> = ({ actions, isWarranty }) => {
    const { t: translate } = useTranslation(['actions-materials', 'orders']);
    const { currency } = useContext(CurrencyContext);

    const actionDescription = (action: ActionGridInput): string => {
        let description = '';

        if (action.actionCode) {
            description += `${action.actionCode} `;
        }
        if (action.description) {
            description += action.description;
        }
        if (action.category) {
            description += ` (${action.category})`;
        }
        return description;
    };

    return (
        <Table className={'dh-compact-table'}>
            <TableHead>
                <TableRow>
                    <TableCell>{translate('orders:ACTION')}</TableCell>
                    <TableCell sx={{ width: 80 }} align="right">
                        {translate('orders:QUANTITY')}
                    </TableCell>
                    <TableCell sx={{ width: 100 }} align="right">
                        {translate('orders:UNIT_PRICE')}
                    </TableCell>
                    <TableCell sx={{ width: 140 }} align="right">
                        {translate('orders:TOTAL_EXCL_VAT')}
                    </TableCell>
                    <TableCell sx={{ width: 90 }} align="right">
                        {translate('orders:VAT_PERCENT')}
                    </TableCell>
                    <TableCell sx={{ width: 140 }} align="right">
                        {translate('orders:TOTAL_INCL_VAT')}
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {actions?.map((action, index) => (
                    <TableRow key={index}>
                        <TableCell>{actionDescription(action)}</TableCell>
                        <TableCell sx={{ width: 80 }} align="right">
                            {action.quantity}
                        </TableCell>
                        <TableCell sx={{ width: 100 }} align="right">
                            {formatCurrency(parseFloat(isWarranty ? '0' : action.unitPrice), currency)}
                        </TableCell>
                        <TableCell sx={{ width: 100 }} align="right">
                            {formatCurrency(isWarranty ? 0 : action.priceWithoutVat, currency)}
                        </TableCell>
                        <TableCell sx={{ width: 90 }} align="right">
                            {isWarranty ? 0 : action.vatPercent}
                        </TableCell>
                        <TableCell sx={{ width: 100 }} align="right">
                            {formatCurrency(isWarranty ? 0 : action.priceWithVat, currency)}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};

export default ConstructionSummaryActions;
